const API_KEY = process.env.REACT_APP_API_KEY 
const SHEET_KEY = process.env.REACT_APP_API_SHEETS_KEY
const SHEET_ID = process.env.REACT_APP_API_SHEETS_ID

export { API_KEY, SHEET_KEY,SHEET_ID };